type Tenant = {
  hideVersion?: boolean
  hideAdminNavLinks?: boolean
  hideRialticOnlyViews: boolean
  singleTenantWorkspaceId: string
  auth0TenantConnection?: string
}

export default defineAppConfig({
  tenant: {
    hideVersion: false,
    hideAdminNavLinks: false,
    hideRialticOnlyViews: false,
    singleTenantWorkspaceId: '',
    auth0TenantConnection: undefined,
  } as Tenant,
  host: '',
  version: '',
})
